/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import {message} from 'antd'
import Page, {page} from '../Pagination/Pagination'
import HeaderTable from '../BaseComponent/HeaderTable'
import {Link} from 'react-router-dom'
import jMoment from 'moment-jalaali'
import REPORT_DISPATCH from '../BaseComponent/REPORTDISPATCH'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import ProductFactorComponent from '../BaseComponent/productFactorComponent'
import ProductFactorPrintComponent from '../BaseComponent/productFactorPrintComponent'

class FactorProductDispatch extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      products: [],
      printInfo: [],
      aggregation: {}
    }
  }

  componentDidMount() {
    sessionStorage.removeItem('params')

    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
    var {productId} = this.props.match.params

    var dispatchId = sessionStorage.getItem('dispatchId')
    sessionStorage.setItem('params', `productId=${productId}&dispatchId=${dispatchId}`)

    http
      .get(
        `${
          REPORT_DISPATCH.REPORT_DISPATCH_PRODUCT_INVOICE_BYDISPATCH
        }?export=false&pageSize=10&pageNumber=1&dispatchId=${dispatchId}&productId=${productId}`,
        {}
      )
      .then((response) => {
        if (response.data.error == null) {
          sessionStorage.setItem('countAll', response.data.object.countAll)

          this.setState({
            products: response.data.object.result,
            lengthProducts: response.data.object.countAll,
            aggregation: response.data.object.aggregation
          })
        } else {
          message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  onResultFetched(data) {
    this.setState({
      products: data
    })
  }

  changeDropDown(data) {
    this.setState({
      products: data,
      lengthProducts: sessionStorage.getItem('countAll')
    })
  }

  getPrintInfo = () => {
    http
      .get(
        `${REPORT_DISPATCH.REPORT_DISPATCH_PRODUCT_INVOICE_BYDISPATCH}?export=true&${sessionStorage.getItem('params')}`,
        {}
      )
      .then((response) => {
        if (response.data.error == null) {
          sessionStorage.setItem('countAll', response.data.object.countAll)

          this.setState({
            printInfo: response.data.object.result,
            aggregation: response.data.object.aggregation
          })
        } else {
          message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  exportExcel = () => {
    http
      .get(
        `${
          REPORT_DISPATCH.REPORT_DISPATCH_PRODUCT_INVOICE_BYDISPATCH
        }?export=true&pageSize=10&pageNumber=1&${sessionStorage.getItem('params')}`,
        {}
      )
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          console.log(response.data)
          // $('.showBaseTable,.print').fadeIn();

          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            excelReport[i]['discount'] = excelReport[i]['discountAmount'] + excelReport[i]['extraDiscountAmount']
          }

          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })

    // this._export.save(excelData)
  }

  render() {
    let urlParams = sessionStorage.getItem('params')

    let excelColumns = [
      {title: 'نام محصول', value: 'productName'},
      {title: 'کد محصول', value: 'productCode'},
      {title: 'نام تامین کننده', value: 'providerName'},
      {title: 'تعداد', value: 'productCount'}
    ]
    const {providerName, productName} = this.props.match.params

    return (
      <div className="rtl printA4Page">
        <ProductFactorPrintComponent
          headerTitlePrint={'فاکتور های کالای :' + productName}
          rightSectionPrint={'در تاریخ : ' + jMoment(Number(this.props.match.params.planDate)).format('jYY/jMM/jDD')}
          centerSectionPrint={'نام رساننده :' + this.props.match.params.name}
          printInfo={this.state.printInfo}
          aggregation={this.state.aggregation}
        />

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName={'فاکتور های  ' + productName + '.xls'}
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'invoiceId'}
                field={'invoiceId'}
                title={'شناسه فاکتور'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'invoiceNum'}
                field={'invoiceNum'}
                title={'شماره فاکتور'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'productQuantityCount'}
                field={'productQuantityCount'}
                title={'تعداد'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'productQuantityValue'}
                field={'productQuantityValue'}
                title={'مقدار'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'productUnitTitle'}
                field={'productUnitTitle'}
                title={'واحد'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'totalAmount'}
                field={'totalAmount'}
                title={'قیمت کل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'discount'}
                field={'discount'}
                title={'تخفیف'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'payableAmount'}
                field={'payableAmount'}
                title={'قابل پرداخت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>{'کالا ها'}</li>
            <li>{'فاکتورهای این  کالا'}</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderTable
                  addUrl=""
                  showRow={false}
                  url={REPORT_DISPATCH.REPORT_DISPATCH_PRODUCT_INVOICE_BYDISPATCH}
                  ChangeDropDown={this.changeDropDown.bind(this)}
                  printUrl="test"
                  printComponent={this.printTable}
                  execelUrl={REPORT_DISPATCH.REPORT_DISPATCH_PRODUCT_INVOICE_BYDISPATCH + '?export=true'}
                  excelColumns={excelColumns}
                  titleAdd=""
                  printLink=""
                />

                <button className={'printButton'} onClick={this.exportExcel}>
                  <i className="fas fa-file-excel" />
                </button>

                <button className="printButton" onClick={this.exportPrint}>
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="detailsInfoTable">
              <ul>
                <li>نام کالا : {productName}</li>
                <li>تامین کننده کالا : {providerName}</li>
                <li>نام رساننده : {this.props.match.params.name}</li>
                <li>تاریخ : {jMoment(Number(this.props.match.params.planDate)).format('jYY/jMM/jDD')}</li>
              </ul>
            </div>

            <ProductFactorComponent factors={this.state.products} aggregation={this.state.aggregation} />

            <div className="paginationWrapp">
              <Page
                defaultCurrent={1}
                total={this.state.lengthProducts}
                onResultFetched={this.onResultFetched.bind(this)}
                url={REPORT_DISPATCH.REPORT_DISPATCH_PRODUCT_INVOICE_BYDISPATCH}
                urlParams={urlParams}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default FactorProductDispatch
